import { DecoupledEditor } from 'ckeditor5'
import {
	Essentials,
	Bold,
	Italic,
	Underline,
	Strikethrough,
	Code,
	Subscript,
	Superscript,
	FontFamily,
	FontSize,
	FontColor,
	FontBackgroundColor,
	Paragraph,
	Heading,
	Link,
	AutoLink,
	List,
	TodoList,
	BlockQuote,
	CodeBlock,
	Table,
	TableToolbar,
	TableColumnResize,
	TableProperties,
	TableCellProperties,
	Image,
	ImageCaption,
	ImageStyle,
	ImageToolbar,
	ImageUpload,
	ImageResize,
	LinkImage,
	MediaEmbed,
	Indent,
	IndentBlock,
	Alignment,
	HorizontalLine,
	RemoveFormat,
	SourceEditing,
	GeneralHtmlSupport,
	Highlight,
	FindAndReplace,
	SpecialCharacters,
	SpecialCharactersEssentials,
	PageBreak,
	WordCount,
	Autoformat,
	TextTransformation,
	PasteFromOffice,
	Base64UploadAdapter
} from 'ckeditor5'
import 'ckeditor5/ckeditor5.css'
import ruTranslations from 'ckeditor5/translations/ru.js'

export const editorPlugins = [
	Essentials,
	Bold,
	Italic,
	Underline,
	Strikethrough,
	Code,
	Subscript,
	Superscript,
	FontFamily,
	FontSize,
	FontColor,
	FontBackgroundColor,
	Paragraph,
	Heading,
	Link,
	AutoLink,
	List,
	TodoList,
	BlockQuote,
	CodeBlock,
	Table,
	TableToolbar,
	TableColumnResize,
	TableProperties,
	TableCellProperties,
	Image,
	ImageCaption,
	ImageStyle,
	ImageToolbar,
	ImageUpload,
	ImageResize,
	LinkImage,
	MediaEmbed,
	Indent,
	IndentBlock,
	Alignment,
	HorizontalLine,
	RemoveFormat,
	SourceEditing,
	GeneralHtmlSupport,
	Highlight,
	FindAndReplace,
	SpecialCharacters,
	SpecialCharactersEssentials,
	PageBreak,
	WordCount,
	Autoformat,
	TextTransformation,
	PasteFromOffice,
	Base64UploadAdapter
]

export const editorTranslations = [ruTranslations]

export { DecoupledEditor }
